import { Component } from '@angular/core';
import { FeedbackPlatformReviewQuestionTypeEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Review Question Types') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformreviewquestiontype-form',
    templateUrl: './feedbackplatformreviewquestiontype.form.component.html'
})
export class FeedbackPlatformReviewQuestionTypeFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformReviewQuestionTypeEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'reviewQuestions', sectionName: 'Review Questions', isExpanded: false }
        ]);
    }
}

